import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useJobProspectsState() {
  return useAppState();
}

export function useJobProspectsActions() {
  const dispatch = useAppDispatch();

  function initializeState({ enrolled, tier, hasPaymentMethod, subscription } = {}) {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      enrolled: enrolled || false,
      tier: tier || null,
      hasPaymentMethod: hasPaymentMethod || false,
      subscription: subscription || null,
      activeTab: 'prospects',
      paymentMethodModalIsOpen: false,
      subscribing: false,
      enrolling: false,
      jobProspects: [],
      jobProspectStatusGroups: [],
      generatingJobProspectIds: [],
      preferredJobLocations: [],
      addingPreferredJobLocation: false,
      selectedStateCode: '',
      jobTitlePreferences: [],
      addingJobTitlePreference: false,
      selectedJobTitle: '',
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function setEnrolled(enrolled, tier) {
    dispatch((appState) => ({
      ...appState,
      enrolled,
      tier,
    }));
  }

  function setActiveTab(tab) {
    dispatch((appState) => ({
      ...appState,
      activeTab: tab,
    }));
  }

  function openPaymentMethodModal() {
    dispatch((appState) => ({
      ...appState,
      paymentMethodModalIsOpen: true,
    }));
  }

  function closePaymentMethodModal() {
    dispatch((appState) => ({
      ...appState,
      paymentMethodModalIsOpen: false,
    }));
  }

  function setSubscribing(subscribing) {
    dispatch((appState) => ({
      ...appState,
      subscribing,
    }));
  }

  function setEnrolling(enrolling) {
    dispatch((appState) => ({
      ...appState,
      enrolling,
    }));
  }

  function addGeneratingJobProspectId(jobProspectId) {
    dispatch((appState) => ({
      ...appState,
      generatingJobProspectIds: [...(appState.generatingJobProspectIds || []), jobProspectId],
    }));
  }

  function removeGeneratingJobProspectId(jobProspectId) {
    dispatch((appState) => ({
      ...appState,
      generatingJobProspectIds: (appState.generatingJobProspectIds || []).filter(id => id !== jobProspectId),
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function openGenerateResumeModal(jobProspectId) {
    dispatch((appState) => ({
      ...appState,
      generateResumeModalIsOpen: true,
      generateResumeJobProspectId: jobProspectId,
    }));
  }

  function closeGenerateResumeModal() {
    dispatch((appState) => ({
      ...appState,
      generateResumeModalIsOpen: false,
      generateResumeJobProspectId: null,
    }));
  }

  function setPreferredJobLocations(locations) {
    dispatch((appState) => ({
      ...appState,
      preferredJobLocations: locations,
    }));
  }

  function setAddingPreferredJobLocation(adding) {
    dispatch((appState) => ({
      ...appState,
      addingPreferredJobLocation: adding,
    }));
  }

  function setSelectedStateCode(code) {
    dispatch((appState) => ({
      ...appState,
      selectedStateCode: code,
    }));
  }

  function setJobTitlePreferences(preferences) {
    dispatch((appState) => ({
      ...appState,
      jobTitlePreferences: preferences,
    }));
  }

  function setAddingJobTitlePreference(adding) {
    dispatch((appState) => ({
      ...appState,
      addingJobTitlePreference: adding,
    }));
  }

  function setSelectedJobTitle(title) {
    dispatch((appState) => ({
      ...appState,
      selectedJobTitle: title,
    }));
  }

  function openConfirmClosedJobModal(jobProspect) {
    dispatch((appState) => ({
      ...appState,
      confirmClosedJobModalIsOpen: true,
      confirmClosedJobForm: jobProspect,
    }));
  }

  function closeConfirmClosedJobModal() {
    dispatch((appState) => ({
      ...appState,
      confirmClosedJobModalIsOpen: false,
      confirmClosedJobForm: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    setEnrolled,
    setActiveTab,
    openPaymentMethodModal,
    closePaymentMethodModal,
    setSubscribing,
    setEnrolling,
    clearFeedback,
    addGeneratingJobProspectId,
    removeGeneratingJobProspectId,
    openGenerateResumeModal,
    closeGenerateResumeModal,
    openConfirmClosedJobModal,
    closeConfirmClosedJobModal,
    setPreferredJobLocations,
    setAddingPreferredJobLocation,
    setSelectedStateCode,
    setJobTitlePreferences,
    setAddingJobTitlePreference,
    setSelectedJobTitle,
  };
}
